<template>
  <div class="rbu-item-module-tender-rates">
    <div
      v-for="(rate, idx) in rates"
      :key="idx"
      class="rbu-item-module-tender-rate"
    >
      <div class="ignored-overlay" v-if="rate.ignored"></div>
      <div class="rbu-item-module-row-column-3">{{ idx + 1 }}</div>
      <div class="rbu-item-module-row-column-value">
        <div class="pa-2">{{ $parseCurrency(rate.value || 0) }}</div>
      </div>
      <div class="rbu-item-module-row-column-multiplier"></div>
      <div class="rbu-item-module-row-column-formula">
        <v-textarea
          outlined
          dense
          hide-details
          placeholder="Formula"
          auto-grow
          rows="1"
          clearable
          :value="rate.formula"
          @input="onRateUpdate(idx, { formula: $event })"
        ></v-textarea>
      </div>
      <div class="rbu-item-module-row-column-descriptions">
        <v-textarea
          outlined
          auto-grow
          rows="1"
          dense
          hide-details
          placeholder="Description"
          :value="rate.descriptions"
          @input="onRateUpdate(idx, { descriptions: $event })"
        ></v-textarea>
      </div>
      <div
        class="rbu-item-module-row-column-actions"
        style="
          display: flex;
          flex-direction: row;
          align-items: top;
          justify-content: start;
        "
      >
        <div
          v-if="!rate.file"
          style="display: flex; flex-direction: column; align-items: center"
        >
          <v-btn icon color="primary" @click="uploadFile(idx)">
            <v-icon>mdi-upload</v-icon>
          </v-btn>
        </div>

        <span v-else>
          <span
            class="rbu-item-module-tender-rate-file"
            @click="showFile(rate.file)"
            >{{
              rate.file instanceof File ? rate.file.name : rate.file.filename
            }}</span
          >
          <v-btn icon small color="primary" @click="removeFile(idx)">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </span>
        <v-btn icon color="primary" @click="deleteRate(idx)">
          <v-icon>mdi-delete</v-icon>
        </v-btn>
        <v-checkbox
          dense
          hide-details
          class="ignore-checkbox ml-4"
          style="
            display: flex;
            flex-direction: column;
            align-items: center;
            padding-top: 0px;
          "
          :input-value="rate.ignored"
          @change="onRateUpdate(idx, { ignored: $event })"
        >
          <template #label>
            <span
              style="
                font-family: Roboto, sans-serif;
                font-size: 14px;
                font-weight: 500;
                font-stretch: 100%;
                letter-spacing: 1.25px;
                line-height: normal;
                text-indent: 1.25px;
              "
              >IGNORE</span
            >
          </template>
        </v-checkbox>
      </div>
    </div>

    <input type="file" hidden ref="fileInput" @change="onFileInputChange" />
  </div>
</template>

<script>
import { ref, watch } from "@vue/composition-api";
import floatingPointFix from "js-floating-point";

export default {
  name: "RbuItemModuleTenderRates",
  props: {
    rates: Array,
  },
  setup(props, { root, emit }) {
    const onRateUpdate = function (idx, d) {
      console.debug("onRateUpdate", idx, d);
      let value = d.value || props.rates[idx].value || 0;

      if (Object.keys(d).includes("formula")) {
        if (d.formula) {
          try {
            value = floatingPointFix(eval(d.formula));
          } catch (e) {
            value = 0;
            console.debug(e);
          }
        }

        if (d.formula === null || d.formula === "") {
          d.formula = "";
          value = 0;
        }
      }

      value = Math.round(floatingPointFix(parseFloat(value) * 100)) / 100;

      let rates = _.concat(props.rates || [], []);
      rates.splice(idx, 1, {
        ...props.rates[idx],
        ...d,
        value,
      });

      emit("input", rates);
    };

    const fileInput = ref();
    const uploadingFileIdx = ref(null);
    const uploadFile = function (idx) {
      uploadingFileIdx.value = idx;
      fileInput.value.click();
    };
    const onFileInputChange = async function (e) {
      const FILE_SIZE_LIMITED = 2 * 1024 * 1024;
      const file = e.target.files[0];
      if (file.size > FILE_SIZE_LIMITED) {
        // let instance = root.$toast.open("You did it!");
        e.target.value = "";
        alert("The file size must not exceed 2MB.");
        // root.$store.dispatch(
        //   ACTION_TYPES.SHOW_SNACKBAR,
        //   `The file size must not exceed 2MB.`
        // );
      } else {
        fileInput.value.value = "";
        if (file) {
          console.debug(uploadingFileIdx.value, file);

          onRateUpdate(uploadingFileIdx.value, {
            file,
          });
        }
      }
    };
    const showFile = function (file) {
      if (file instanceof File) {
        const url = URL.createObjectURL(file);
        window.open(url, "_blank");
      } else {
        root.$downloadFile(file.id);
      }
    };
    const removeFile = function (idx) {
      onRateUpdate(idx, {
        file: null,
      });
    };

    const deleteRate = function (idx) {
      let rates = _.concat(props.rates || [], []);
      rates.splice(idx, 1);

      emit("input", rates);
    };

    return {
      onRateUpdate,
      fileInput,
      uploadFile,
      onFileInputChange,
      showFile,
      removeFile,
      deleteRate,
      File,
    };
  },
};
</script>

<style lang="less">
.rbu-item-module-tender-rates {
  display: flex;
  flex-direction: column;
  gap: 16px;

  .rbu-item-module-tender-rate {
    display: flex;
    gap: 8px;
    position: relative;

    .ignored-overlay {
      position: absolute;
      width: 1380px;
      height: 100%;
      background-color: rgba(0, 0, 0, 0.3);
    }

    .rbu-item-module-tender-rate-file {
      // font-size: 80%;
      // font-size: 24px;
      font-size: 100%;
      word-break: break-all;
      text-decoration: underline;
      color: var(--v-primary-base);
      cursor: pointer;
      max-width: 100px;
      overflow: hidden;
    }
  }
}
</style>
